const countriesModel = vm => ({
  title: vm.$gettext('Countries'),
  endpoint: 'countries',
  allowNew: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'iso_code',
      label: vm.$gettext('ISO Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('ISO CODE 3166-1 alpha 2 (ie. AR)')
    },
    {
      key: 'phone_code',
      label: vm.$gettext('Phone Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext("Country's Phone Code <strong>without plus (+) sign</strong>")
    },
    {
      key: 'currency',
      label: vm.$gettext('Currency'),
      editable: true,
      required: true,
      description: vm.$gettext('Currency (Main currency ISO CODE 4217. Ie. ARS)')
    },
    {
      key: 'vat_percentage',
      label: vm.$gettext('VAT Percentage'),
      editable: true,
      description: vm.$gettext('VAT Percentage for the country (ie. 21.00)')
    },
    {
      key: 'language',
      label: vm.$gettext('Language'),
      editable: true,
      required: true,
      description: vm.$gettext('Language Locale (ISO 15897 code, ie. es_AR or pt_BR)')
    },
    {
      key: 'timezone',
      label: vm.$gettext('TimeZone'),
      editable: true,
      required: true,
      description: vm.$gettext(
        'TimeZone for dates on the country. Should be one present at: <a href="https://www.php.net/manual/es/timezones.php" target="_blank">https://www.php.net/manual/es/timezones.php</a>'
      )
    },
    {
      key: 'cut_time',
      label: vm.$gettext('Cut Hour'),
      editable: true,
      required: true,
      description: vm.$gettext('Cut hour for same-day shippings'),
      type: 'time',
      step: 1
    },
    {
      key: 'close_hours_treshold',
      label: vm.$gettext('Close Hours Threshold'),
      editable: true,
      type: 'integer',
      description: vm.$gettext(
        'Number of hours the shop must remain open after creating a shipping to deliver the same day'
      )
    },
    {
      key: 'credit_threshold',
      label: vm.$gettext('Credit Threshold'),
      editable: true,
      required: false,
      description: vm.$gettext(
        'Credit (credit_limit - balance) the account must have to create new shippings'
      )
    },
    {
      key: 'cod_max_carrying_cash',
      label: vm.$gettext('COD Max. Carrying Cash'),
      editable: true,
      required: false,
      description: vm.$gettext('Max amount of cash the user can carry before being forced to deposit')
    },
    {
      key: 'individual_terms',
      label: vm.$gettext('Individual Terms'),
      editable: true,
      description: vm.$gettext('Current terms of use for independent couriers')
    },
    {
      key: 'companies_terms',
      label: vm.$gettext('Companies Terms'),
      editable: true,
      description: vm.$gettext('Current terms of use for couriers belonging to a company')
    },
    {
      key: 'couriers_contract_model',
      label: vm.$gettext("Couriers' Contract Model"),
      editable: true,
      description: vm.$gettext('If required in the country the contract the couriers need to sign to work')
    },
    {
      key: 'couriers_contract_days',
      label: vm.$gettext("Couriers' Contract Days"),
      editable: true,
      type: 'integer',
      description: vm.$gettext('Number of days the contract signed by the courier is valid')
    },
    {
      key: 'max_working_hours_allowed',
      label: vm.$gettext('Max. Working Hours'),
      editable: true,
      type: 'integer',
      description: vm.$gettext('Maximum number of hours a courier is allowed to be working')
    },
    {
      key: 'front_config',
      label: vm.$gettext('Front Config'),
      editable: true,
      type: 'JSON'
    }
  ],
  filters: ['id', 'name', 'iso_code'],
  exclude: ['front_config']
})

export default countriesModel
